export enum Role {
  MBS = 'MBS',
  Maker = 'MAKER',
  Company = 'COMPANY',
  Division = 'DIVISION',
  Office = 'OFFICE',
  Agency = 'AGENCY'
}
